export const enListSignals = {
	title: "Signals Configuration",
	globalFilters: "Global Filters",
	onlyTriggerOnEmployee: "Only trigger on employee",
	includeInEngagementScore: "Include in engagement score calculation",
	aiPrompts: "AI Prompts",
	deepResearchPrompt: "Deep Research Prompt",
	deepResearchPromptPlaceholder: "Enter prompt for deep research...",
	signalCategorization: "How Signals will be categorized",
	leadUpdates: "Lead updates",
	leadUpdatesPlaceholder: "Enter prompt for categorizing lead updates...",
	companyUpdates: "Company updates",
	companyUpdatesPlaceholder: "Enter prompt for categorizing company updates...",
	industryUpdates: "Industry updates",
	industryUpdatesPlaceholder: "Enter prompt for categorizing industry updates...",
	systemPrompt: "System Prompt",
	systemPromptPlaceholder: "Enter system prompt...",
	researchOptions: "Research Options",
	checkLinkedinPosts: "Check of LinkedIn posts",
	analyzeLinkedinEngagement:
		"Analyze LinkedIn engagement of a lead (what does he/she like or comment on)",
	checkTechStackChanges: "Changes in Tech Stack",
	signalTypes: "Signal Types",
	categorizationPrompt: "Categorization Prompt",
	categorizationPromptPlaceholder: "Enter categorization prompt for this signal type...",
	priorityDefinitions: "Priority Definitions",
	priorityDefinitionsDescription:
		"Define criteria for prioritizing signals. Each priority level can have multiple definitions with titles, definitions, and examples.",
	priority1: "Priority 1",
	priority2: "Priority 2",
	priority3: "Priority 3",
	disqualified: "Disqualified",
	highest: "Highest",
	lowest: "Lowest",
	unknown: "Unknown",
	items: "items",
	noPriorityItemsDefined: "No items defined for this priority level",
	addPriorityItem: "Add",
	editPriorityItem: "Edit Priority Item",
	deletePriorityItem: "Delete Priority Item",
	movePriorityItem: "Drag to another priority",
	addPriorityItemTitle: "Add Priority Item",
	definition: "Definition",
	examples: "Examples",
	examplePlaceholder: "Enter an example...",
	addExample: "Add Example",
	// Test signal config
	testConfiguration: "Test Configuration",
	testLoading: "Running AI pipeline… this may take 15–60 seconds.",
	testNoCredits: "No credits will be charged.",
	testResults: "Test Results",
	testSelectedOrganization: "Selected Organization",
	testQualityScore: "Quality Score",
	testConfigSource: "Config Source",
	testSummary: "Summary",
	testTotalSignals: "Total Signals",
	testPrio1: "Prio 1",
	testPrio2: "Prio 2",
	testPrio3: "Prio 3",
	testDisqualified: "Disqualified",
	testLeadUpdates: "Lead Updates",
	testCompanyUpdates: "Company Updates",
	testIndustryUpdates: "Industry Updates",
	testScoredSignals: "Scored Signals",
	testRawSignals: "Raw Signals",
	testTitle: "Title",
	testCategory: "Category",
	testPriority: "Priority",
	testReasoning: "Reasoning",
	testSource: "Source",
	testNoSignals: "No signals found.",
	testByPriority: "By Priority",
	testByCategory: "By Category",
	tabs: {
		signals: "Signals",
		signalsHistory: "Signals History",
	},
	history: {
		user: "Changed by",
		previousPriority: "Previous Priority",
		newPriority: "New Priority",
		changedAt: "Changed at",
		noPreviousPriority: "Not set",
		noHistory: "No priority change history found.",
		signalTitle: "Signal",
		signalCategory: "Category",
		organizationName: "Organization",
	},
	outputLanguage: "AI output language",
	outputLanguageInfo:
		"Language in which generated signals (titles, summaries and reasoning) are written.",
};
